@let uploadedFilesValue = uploadedFiles();

<rt-dialog-header
  [heading]="'tlc.positions.import_skills_flow.upload_file.heading' | translate"
  [subheading]="'tlc.positions.import_skills_flow.upload_file.subheading' | translate"
/>

<rt-dialog-body variant="white">
  <tl-stepper [steps]="steps" />

  <rt-heading variant="heading bold" class="section-heading">
    {{ 'tlc.positions.import_skills_flow.upload_file.upload_section.heading' | translate }}
  </rt-heading>
  <span class="supported-formats" [class.lower-margin]="uploadedFilesValue">
    {{
      'tlc.positions.import_skills_flow.upload_file.upload_section.supported_formats' | translate
    }}
  </span>

  @if (!uploadedFilesValue) {
    <rt-infobox
      iconName="ai"
      iconColor="colorIconAiDefault"
      [isDismissible]="false"
      [type]="'brand'"
      class="ai-notice"
    >
      <span
        [innerHTML]="'tlc.positions.import_skills_flow.upload_file.ai_notice_infobox' | translate"
      ></span>
    </rt-infobox>
  }

  @if (!uploadedFilesValue) {
    <tl-upload-file-box
      [accept]="accept"
      [savedFile]="undefined"
      [error]="undefined"
      [isUploading]="isUploading()"
      [maxFileSize]="maxFileSize"
      [multiple]="true"
      (filesSelected)="onFilesSelected($event)"
      (validationError)="onValidationError($event)"
      #uploadFileBox
    >
      <ng-container empty>
        <div class="upload-body">
          <rt-icon
            name="upload-file"
            size="large-x"
            class="upload-icon"
            colorToken="colorIconLowDefault"
          />
          <rt-heading variant="heading large-x bold">
            {{
              'tlc.positions.import_skills_flow.upload_file.upload_section.upload_box.title'
                | translate
            }}
          </rt-heading>
          <span>
            {{
              'tlc.positions.import_skills_flow.upload_file.upload_section.upload_box.subtitle'
                | translate
            }}
          </span>
          <rt-button (click)="uploadFileBox.openFilePicker()" variant="primary">
            <rt-icon name="file-upload" />
            {{
              'tlc.positions.import_skills_flow.upload_file.upload_section.upload_box.upload_file'
                | translate
            }}
          </rt-button>
        </div>
      </ng-container>

      <ng-container dragOver>
        <div class="upload-body">
          <rt-icon name="file-upload" size="large-x" colorToken="colorIconActive" />
          <rt-heading variant="heading">
            {{ 'tlc.positions.import_skills_flow.upload_file.drop_file_here' | translate }}
          </rt-heading>
        </div>
      </ng-container>

      <ng-container uploaded />
      <ng-container error />
    </tl-upload-file-box>
  } @else {
    <div class="uploaded-files-list">
      @for (file of uploadedFilesValue; track file.name) {
        <div class="uploaded-file-row">
          <rt-icon name="file-document" colorToken="colorIconDefault" />
          <span class="uploaded-file-name">{{ file.name }}</span>
        </div>
      }
    </div>
  }

  @if (uploadedFilesValue) {
    <div class="files-summary">
      @if (isUploading()) {
        <div class="loading-row">
          <rt-spinner variant="small-x" />
          <span class="loading-message">
            {{
              'tlc.positions.import_skills_flow.upload_file.additional_instructions.loading_message'
                | translate
            }}
          </span>
          <rt-button class="clear-files-button" variant="plain" size="small" (click)="clearFiles()">
            <rt-icon name="clear" />
            <span>{{
              'tlc.positions.import_skills_flow.upload_file.additional_instructions.clear_files'
                | translate
            }}</span>
          </rt-button>
        </div>
      } @else {
        <div class="files-summary-row">
          <span class="files-count">{{
            'tlc.positions.import_skills_flow.upload_file.additional_instructions.files_count'
              | translate: { count: uploadedFilesValue?.length }
          }}</span>
          <rt-button variant="plain" size="small" (click)="clearFiles()">
            <rt-icon name="clear" />
            <span>{{
              'tlc.positions.import_skills_flow.upload_file.additional_instructions.clear_files'
                | translate
            }}</span>
          </rt-button>
        </div>
      }
    </div>

    <div class="checkbox-section">
      <rt-heading variant="heading bold" class="section-heading">
        {{
          'tlc.positions.import_skills_flow.upload_file.additional_instructions.file_content.heading'
            | translate
        }}
      </rt-heading>
      <span class="section-description">
        {{
          'tlc.positions.import_skills_flow.upload_file.additional_instructions.file_content.description'
            | translate
        }}
      </span>

      <div class="checkboxes">
        @for (option of fileContentOptions; track option.label) {
          <rt-checkbox [formControl]="option.control">{{ option.label }}</rt-checkbox>
        }
      </div>
    </div>

    <div class="instructions-section">
      <rt-heading variant="heading bold" class="section-heading">
        {{
          'tlc.positions.import_skills_flow.upload_file.additional_instructions.additional_instructions.heading'
            | translate
        }}
      </rt-heading>
      <span class="section-description">
        {{
          'tlc.positions.import_skills_flow.upload_file.additional_instructions.additional_instructions.description'
            | translate
        }}
      </span>

      <rt-textarea
        [formControl]="additionalInstructions"
        [invalid]="additionalInstructions.invalid"
        [placeholder]="
          'tlc.positions.import_skills_flow.upload_file.additional_instructions.additional_instructions.placeholder'
            | translate
        "
        [charactersLimit]="maxInstructionsLength"
        [rows]="2"
        [hasCharactersLimitDivider]="true"
        class="instructions-textarea"
      />
    </div>
  }
</rt-dialog-body>

<rt-dialog-footer variant="white">
  <rt-button variant="plain" (click)="cancel()">{{ 'tlc.common.cancel' | translate }}</rt-button>
  @if (uploadedFilesValue) {
    <rt-button variant="primary" [disabled]="isContinueDisabled()" (click)="continue()">
      <span>{{ 'tlc.common.continue' | translate }}</span>
      <rt-icon name="arrow-forward" />
    </rt-button>
  }
</rt-dialog-footer>
